import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { toggleCheckedItem, toggleEditModal, setPage, to, setSortListEndpoint } from '../../store/sportsTabSlice';

import ClasicArrowDown from '../../components/icons/clasic-arrow-down.jsx';
import ClasicArrowUp from '../../components/icons/clasic-arrow-up.jsx';

import store from '../../store/store.js';


export const changeSortingListConfiguration = async( sort ) => { 
  ApiService.setSortListEndpoint(sort);  
}


export const fetchSports = async (sortBy, sortDirection, keyword, currentPage, dispatch, setMaxPages, setRows, checkedItems) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const response = await ApiService.getSports(checkedSortBy, checkedSortDirection, keyword, currentPage);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPages(response.maxPage)); // Ustawienie maksymalnej liczby stron na podstawie danych z API

    const sortResponse = await ApiService.getSortListEndpoint();
    console.log('Odpowiedź z API sortowania:', sortResponse);
    dispatch(setSortListEndpoint(sortResponse)); // Ustawienie endpointu sortowania

    // Mapowanie danych z API do formatu zgodnego z tabelą
    const mappedRows = response.data.map((sport, index) => [
      <input
        type="checkbox"
        checked={checkedItems.includes(sport[0])} // Sprawdzenie, czy id znajduje się w checkedItems
        onChange={() => dispatch(toggleCheckedItem(sport[0]))} // Dodanie/Usunięcie id z listy
      />,
      sport[0], // ID
      sport[1],
      sport[2],
      sport[6],
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img className='row-image' src={"https://api-dev.teamme.pl/images/" + sport[4]} alt="FOTO" />
      </div>,
      <div className="line-with-arrows">
        { index === 0 && currentPage === 1 && (
          <div className="clasic-arrow-no-action"> <ClasicArrowUp color="#dddddd" onClick={async () => {}} /></div>)}      
        {((index !== 0 && currentPage === 1) || (currentPage > 1)) &&  ( // Wykluczenie akcji moveSportUp dla pierwszego elementu
          <div className="clasic-arrow">
            <ClasicArrowUp onClick={async () => {
              await ApiService.moveSportUp(sport[3]);
              await fetchSports(sortBy, sortDirection, currentPage, dispatch, setMaxPages, setRows, checkedItems);
            }} />
          </div>)}
        <div className="flex-content">{sport[3]}</div>
        {index === response.data.length - 1 && currentPage === response.maxPage && ( 
          <div className="clasic-arrow-no-action"><ClasicArrowDown  color="#dddddd"  onClick={async () => {}} /></div>)}
        { ((index !== response.data.length - 1 && currentPage === response.maxPage) || currentPage < response.maxPage) && ( 
          <div className="clasic-arrow"><ClasicArrowDown onClick={async () => {
            await  ApiService.moveSportDown(sport[3]);
            await fetchSports(sortBy, sortDirection, currentPage, dispatch, setMaxPages, setRows, checkedItems);
          }} /></div>)}
      </div>,
      sport[5] ? 'Aktywny' : 'Nieaktywny',
      <div>
        <Edit
          className="menu-icon"
          onClick={() => dispatch(toggleEditModal({
            id: sport[0],
            name: sport[1],
            englishName: sport[2],
            thumbnail: sport[4],
            active: sport[5],
            order: sport[3], // Dodaj pole order
          }))}
          />
      </div>
    ]);

    setRows(mappedRows); // Ustawienie wierszy w stanie
    let currentPageState = store.getState().sports.currentPage;
    keyword && currentPageState !== 1 && dispatch(setPage(1)); // Resetowanie strony przy wyszukiwaniu
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};